import React from 'react';
import Widget from "./widget";
import {TableView, TableHeader, Column, Row, TableBody, Cell, Flex, View} from '@adobe/react-spectrum';
import useDashboard from "state/dashboard/hooks/useDashboard";
import CheckmarkCircle from "@spectrum-icons/workflow/CheckmarkCircle";
import styled from "styled-components";

const Description = styled.div`
  color: #6E6E6E;
  text-transform: capitalize;
`;

const bytesToGbBinary = item => {
  return Math.ceil(item / (1024 * 1024 * 1024)) + ' GB';
}

// Decimal GB - matches PHP's pow(10, 9)
const bytesToGbDecimal = item => {
  return (item / Math.pow(10, 9)).toFixed(2) + ' GB';
}

const NewRelicStorageDetailsInfoWidget = layoutItem => {
  const [dashboard,,] = useDashboard();

  if (dashboard.widget.newRelicStorageDetailsInfo.length === 0) {
    return <Widget title={'Storage Info'}>
      <Flex direction={'column'} alignItems={'center'} justifyContent={'center'} height="100%" width="100%">
        <CheckmarkCircle color={'positive'} size={'XL'} marginBottom={'10px'}/>
        <Description>No Information Available</Description>
      </Flex>
    </Widget>
  }

  return <Widget layoutItem={layoutItem} title="Storage Info">
    {
      dashboard.widget.newRelicStorageDetailsInfo.map((item) => <Flex width={'100%'} direction="column" UNSAFE_style={{overflow: 'hidden'}} key={item.id}>
          {
            console.log('item', JSON.parse(item.result).db)}
        <TableView aria-label="Storage Info" flexGrow isQuiet UNSAFE_style={{margin: '0 -1rem' ,border:'none'}}>
          <TableHeader>
            <Column align={'start'} width={'22%'}>Path</Column>
            <Column align={'start'} width={'14%'}>Type</Column>
            <Column align={'start'} width={'24%'}>
              Total<br/>
              (Bin/Dec)
            </Column>
            <Column align={'start'} width={'23%'}>
              Free<br/>
              (Bin/Dec)
            </Column>
            <Column align={'start'} width={'15%'}>Used</Column>
          </TableHeader>
          <TableBody UNSAFE_stye={{border:'none'}} >
            <Row>
              <Cell>{JSON.parse(item.result).db['facet']}</Cell>
              <Cell>{JSON.parse(item.result).db['type']}</Cell>
              <Cell>
                {bytesToGbBinary(JSON.parse(item.result).db['total_bytes'])}
                <br/>
                {bytesToGbDecimal(JSON.parse(item.result).db['total_bytes'])}
              </Cell>
              <Cell>
                {bytesToGbBinary(JSON.parse(item.result).db['free_bytes'])}
                <br/>
                {bytesToGbDecimal(JSON.parse(item.result).db['free_bytes'])}
              </Cell>
              <Cell>{Math.ceil(JSON.parse(item.result).db['used_percent'])}%</Cell>
            </Row>
            <Row>
              <Cell>{JSON.parse(item.result).media['facet']}</Cell>
              <Cell>{JSON.parse(item.result).media['type']}</Cell>
              <Cell>
                {bytesToGbBinary(JSON.parse(item.result).media['total_bytes'])}
                <br/>
                {bytesToGbDecimal(JSON.parse(item.result).media['total_bytes'])}
              </Cell>
              <Cell>
                {bytesToGbBinary(JSON.parse(item.result).media['free_bytes'])}
                <br/>
                {bytesToGbDecimal(JSON.parse(item.result).media['free_bytes'])}
              </Cell>
              <Cell>{Math.ceil(JSON.parse(item.result).media['used_percent'])}%</Cell>
            </Row>
          </TableBody>
        </TableView>
        <Flex direction="row" UNSAFE_style={{display: 'block', marginTop: '30px'}}>
          {/*{renderNewRelicStorageDetails(item)}*/}
        </Flex>
      </Flex>
      )
    }
    </Widget>;
};

export default NewRelicStorageDetailsInfoWidget;
